import React from "react";
import { FunctionField, Record } from "react-admin";
import {
    Box,
    Chip,
    Tooltip,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { green, orange, blueGrey, grey } from "@material-ui/core/colors";


import { FaFileSignature } from "react-icons/fa6";
import { FaFileUpload } from "react-icons/fa";

import { FaFileCircleExclamation } from "react-icons/fa6";
import { FaClipboardList } from "react-icons/fa6";

const useStyles = makeStyles((theme) => ({
    group: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.25),
        flexWrap: "nowrap",
        justifyContent: "flex-start",
    },
    chipBase: {
        height: 22,
        width: 90,
        padding: "0 6px",
        fontWeight: 600,
        justifyContent: "flex-start",
        "& .MuiChip-icon": {
            marginLeft: 2,
            marginRight: 4,
        },
    },
    tooltipBox: {
        whiteSpace: "pre-line",
        padding: theme.spacing(1),
        lineHeight: 1.4,
    },
    must: { background: "#e8ebed", color: "#2c3e50" },
    unique: { background: "#f2f2f2", color: "#444" },
    initial: { background: "#fff3e0", color: "#e65100" },
    final: { background: "#e8f5e9", color: "#2e7d32" },
    legendRow: {
        display: "grid",
        gridTemplateColumns: "min-content 1fr auto",
        columnGap: theme.spacing(1),
        alignItems: "center",
        padding: theme.spacing(0.5, 0),
    },
    legendDot: {
        width: 10,
        height: 10,
        borderRadius: "50%",
        display: "inline-block",
    },
    dotMust: { backgroundColor: blueGrey[500] },
    dotUnique: { backgroundColor: grey[600] },
    dotInitial: { backgroundColor: orange[700] },
    dotFinal: { backgroundColor: green[700] },
}));

const NotesCounter: React.FC = () => {
    const classes = useStyles();

    return (
        <FunctionField
            label="Bolle"
            render={(record?: Record) => {
                if (!record || !record.notes_stats) return null;

                const s = record.notes_stats;
                const items = [
                    {
                        key: "must",
                        value: s.value_must ?? 0,
                        label: "Devono avere la bolla",
                        className: classes.must,
                        icon: <FaFileCircleExclamation fontSize="small" className={classes.must} />,
                        dotClass: classes.dotMust,
                    },
                    {
                        key: "unique",
                        value: s.value_unique ?? 0,
                        label: "Con almeno una bolla",
                        className: classes.unique,
                        icon: <FaClipboardList fontSize="small" className={classes.unique} />,
                        dotClass: classes.dotUnique,
                    },
                    {
                        key: "initial",
                        value: s.value_initial ?? 0,
                        label: "Con bolla iniziale",
                        className: classes.initial,
                        icon: <FaFileUpload fontSize="small" className={classes.initial} />,
                        dotClass: classes.dotInitial,
                    },
                    {
                        key: "final",
                        value: s.value_final ?? 0,
                        label: "Con bolla finale firmata",
                        className: classes.final,
                        icon: <FaFileSignature fontSize="small" className={classes.final} />,
                        dotClass: classes.dotFinal,
                    },
                ];

                const tooltip = (
                    <Box className={classes.tooltipBox}>
                        <Typography variant="subtitle2" gutterBottom>
                            Dettaglio bolle
                        </Typography>
                        {items.map((i) => (
                            <Box key={i.key} className={classes.legendRow}>
                                <span className={`${classes.legendDot} ${i.dotClass}`} />
                                <Typography variant="body2">{i.label}</Typography>
                                <Typography variant="body2" style={{ fontWeight: 700 }}>
                                    {i.value}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                );

                return (
                    <Tooltip title={tooltip} arrow enterDelay={200}>
                        <Box className={classes.group}>
                            {items.map((i) => (
                                <Chip
                                    key={i.key}
                                    size="small"
                                    label={i.value}
                                    icon={i.icon}
                                    className={`${classes.chipBase} ${i.className}`}
                                />
                            ))}
                        </Box>
                    </Tooltip>
                );
            }}
        />
    );
};

export default NotesCounter;
